import './../scss/layouts.scss';
import 'slick-carousel';
import 'imagesloaded';
import 'jquery';
import './layouts/mosaic';

jQuery(document).ready(function ($) {
  $('.wst-slider').each(function () {
    let _slider = $(this);
    _slider.imagesLoaded(function () {
      _slider.addClass('show').slick({
        arrows: _slider.hasClass('wst-slider--with-arrows'),
        dots: _slider.hasClass('wst-slider--with-dots'),
        draggable: $('html').hasClass('touchevents'),
        autoplay: true,
        autoplaySpeed: 4000
      });
    });
  });
});
